<template>
    <div class="tab-content">
        <h2 class="tab-content--title">
            Reset Your Password
        </h2>
        <p class="tab-content--subtitle">
            {{
                $store.state.isCodeSent
                    ? 'Please check your email for a message with your code and create a new password below'
                    : 'Leave us your email address and we\'ll send a code to reset your password'
            }}
        </p>

        <reset-password-confirm-form
            v-if="$store.state.isCodeSent"
            @submit="onSubmit" />
        <app-email-form
            v-else
            @sent="sendCode" />
    </div>
</template>

<script>
import ResetPasswordConfirmForm from '@/components/ResetPassword/ResetPasswordConfirmForm';
import AppEmailForm from '@/components/App/AppEmailForm';

export default {
    name: 'ResetPassword',

    components: {
        AppEmailForm,
        ResetPasswordConfirmForm,
    },

    data() {
        return {
            email: null,
        };
    },

    methods: {
        sendCode(ev) {
            this.email = ev;
            this.$store.dispatch('forgotPassword', ev);
        },

        onSubmit(ev) {
            this.$store.dispatch('forgotPasswordSubmit', {
                ...ev,
                email: this.email,
            });
        },
    },
};
</script>

<style></style>